import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";
import {getUserApiData} from "../../utils/UserUtils";
import {myID} from "../../libs/generateID";
import store from "../../store/store";
import {notify} from "reapop";
import i18n from "../../i18n";

export function editSowCycle(data, {FarmID, ClientID, LocalUserID} = {}) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({FarmID, ClientID, LocalUserID});
    return invokeApig({
        ...Paths.editSowCycle({farmID: _FarmID, clientID: _ClientID, localUserID: _LocalUserID}),
        body: data,
    })
}

export function editSowCycleNotificationSuccess(response, {uniqueId = myID()} = {}) {
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("popNotifications.sowCardUpdateTitle"),
        message: i18n.t("popNotifications.sowCardUpdateSuccess"),
        status: "success",
        dismissible: true,
        dismissAfter: 5000
    }))
}

export function editSowCycleNotificationFailure(response, {uniqueId = myID()} = {}) {
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("popNotifications.sowCardUpdateTitle"),
        message: i18n.t("popNotifications.sowCardUpdateFailure"),
        status: "error",
        dismissible: true,
        dismissAfter: 15000
    }))
}
